export default "https://cdn-static.gokick.com/assets/a667d1dc3297954618d7ed7be4de1ad72d2b7ee9/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";